(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liams-contact-page"] && !Shopify.designMode) return;
  try {
    
(function(){function setup(root){(root||document).querySelectorAll('[data-l2i-contact-whatsapp]:not([data-l2i-ready])').forEach(function(form){form.setAttribute('data-l2i-ready','true');form.addEventListener('submit',function(e){e.preventDefault();var lines=["Hi Liam, I'd like to send an enquiry from the Liam's 2nd Innings website:"];form.querySelectorAll('[data-wa-field]').forEach(function(field){var value=(field.value||'').trim();if(value){lines.push((field.getAttribute('data-wa-label')||'Detail')+': '+value);}});var url='https://wa.me/27633689528?text='+encodeURIComponent(lines.join('\n'));window.open(url,'_blank','noopener');});});}setup(document);document.addEventListener('shopify:section:load',function(e){setup(e.target);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liams-refurb-highlight"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-l2i-compare]').forEach((c)=>{const r=c.querySelector('.l2i-compare__range');if(!r)return;const u=()=>c.style.setProperty('--l2i-compare',`${r.value}%`);r.addEventListener('input',u);u();});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liams-service-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){(root||document).querySelectorAll('[data-l2i-whatsapp-form]:not([data-l2i-ready])').forEach(function(form){form.setAttribute('data-l2i-ready','true');form.addEventListener('submit',function(event){event.preventDefault();var lines=["Hi Liam, I'd like to submit a "+(form.getAttribute('data-purpose')||'website enquiry')+':'];form.querySelectorAll('[data-wa-field]').forEach(function(field){var value=(field.value||'').trim();if(value){lines.push((field.getAttribute('data-wa-label')||'Detail')+': '+value);}});lines.push('I will attach photos in WhatsApp where relevant.');window.open('https://wa.me/27633689528?text='+encodeURIComponent(lines.join('\n')),'_blank','noopener');});});}
  setup(document);document.addEventListener('shopify:section:load',function(e){setup(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liams-transformation-proof"] && !Shopify.designMode) return;
  try {
    
(function(){
  function bindVideo(video){
    if(video.dataset.l2iBound==='true') return;
    video.dataset.l2iBound='true';
    var wrap=video.closest('.l2i-proof__media');
    if(!wrap) return;
    var button=wrap.querySelector('[data-l2i-play]');
    video.addEventListener('play',function(){ if(button) button.hidden=true; });
    video.addEventListener('pause',function(){ if(button) button.hidden=false; });
    video.addEventListener('ended',function(){ if(button) button.hidden=false; });
    video.addEventListener('error',function(){ if(button){ button.hidden=false; button.classList.add('is-error'); var label=button.querySelector('span:last-child'); if(label) label.textContent='Try again'; } });
    video.addEventListener('loadedmetadata',function(){ if(button){ button.classList.remove('is-error'); var label=button.querySelector('span:last-child'); if(label) label.textContent='Play film'; } });
  }
  function init(scope){ (scope||document).querySelectorAll('[data-l2i-proof-video]').forEach(bindVideo); }
  init(document);
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-l2i-play]');
    if(!button) return;
    var wrap=button.closest('.l2i-proof__media');
    var video=wrap ? wrap.querySelector('[data-l2i-proof-video]') : null;
    if(!video) return;
    event.preventDefault();
    if(video.paused){
      var promise=video.play();
      if(promise && promise.catch){ promise.catch(function(){ video.load(); video.play().catch(function(){ button.classList.add('is-error'); var label=button.querySelector('span:last-child'); if(label) label.textContent='Try again'; }); }); }
    }else{ video.pause(); }
  });
  document.addEventListener('shopify:section:load',function(event){ init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
